import React, { useState } from 'react';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ParaglidingIcon from '@mui/icons-material/Paragliding';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import Dialog from '@mui/material/Dialog';
import '../styles/Calendar.scss';

export default function Calendar(props) {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [dialogState, setDialogState] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const getDaysInMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };

    const getFirstDayOfMonth = (date) => {
        const day = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
        return day === 0 ? 6 : day - 1;
    };

    const previousMonth = () => {
        const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
        setCurrentDate(newDate);
        props.setDataByDate(newDate.getFullYear(), newDate.getMonth() + 1);
    };

    const nextMonth = () => {
        const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
        setCurrentDate(newDate);
        props.setDataByDate(newDate.getFullYear(), newDate.getMonth() + 1);
    };

    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);
    const days = [];

    for (let i = 0; i < firstDay; i++) {
        days.push(null);
    }

    for (let i = 1; i <= daysInMonth; i++) {
        days.push(i);
    }

    // Get data passed as props
    const activityData = Array.isArray(props.data) ? props.data : [];
    const monthActivityData = activityData.filter(item => 
        parseInt(item.activity_date_month) === currentDate.getMonth() + 1 &&
        parseInt(item.activity_date_year) === currentDate.getFullYear()
    );
    // Order activityData by day
    const sortedActivityData = [...monthActivityData].sort((a, b) => {
        return parseInt(a.activity_date_day) - parseInt(b.activity_date_day);
    });



    const openDialogAndLoadData = (day, month, year) => {
        if (day === null) return;
        setDialogData(sortedActivityData.filter(item => 
            parseInt(item.activity_date_day) === day && 
            parseInt(item.activity_date_month) === month &&
            parseInt(item.activity_date_year) === year
        ));
        setDialogState(true);
    }

    const getDaySuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const currentWeight = (() => {
        const lastDayData = [...sortedActivityData].reverse().find(item => 
            item.activity_weight !== "0"
        );
        return lastDayData ? parseFloat(lastDayData.activity_weight) : null;
    })();

    const globalData = props.globalData;
    var goalWeight = globalData && globalData.length > 0 ? globalData[0].year_target : null;
    var weightToGo = currentWeight && goalWeight ? (currentWeight - goalWeight).toFixed(1) : 'N/A';
    var avgWeight = 0;
    const monthStepsTotal = sortedActivityData.reduce((total, item) => total + (parseInt(item.activity_steps) || 0), 0);
    const monthBikeTotal = sortedActivityData.reduce((total, item) => total + (parseInt(item.activity_bike) || 0), 0);
    const monthWeightEntries = sortedActivityData.filter(item => parseFloat(item.activity_weight) > 0);
    const averageWeight = monthWeightEntries.length > 0
        ? (monthWeightEntries.reduce((total, item) => total + (parseFloat(item.activity_weight) || 0), 0) / monthWeightEntries.length).toFixed(1)
        : 'N/A';
    const today = new Date();
    const isCurrentMonth = currentDate.getMonth() === today.getMonth() && currentDate.getFullYear() === today.getFullYear();
    const daysUsed = isCurrentMonth ? today.getDate() : daysInMonth;
    const averageSteps = daysUsed ? Math.round(monthStepsTotal / daysUsed) : 0;
    const averageBike = daysInMonth ? Math.round(monthBikeTotal / daysUsed) : 0;
    const totalPressUps = sortedActivityData.reduce((total, item) => total + (parseInt(item.activity_pressups) || 0), 0);

    return (
        <div className="calendar-container">
            <div className="calendar-header">
                <h2>{currentDate.toLocaleString('default', { month: 'short', year: 'numeric' })}</h2>
                <div className="calendar-header-date-changer">
                    <button className="calendar-button" onClick={previousMonth}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/></svg>
                    </button>
                    
                    <button className="calendar-button" onClick={nextMonth}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/></svg>
                    </button>
                </div>
            </div>

            <div className="calendar-month-statistics">
                <div className={`calendar-month-statistic ${averageSteps >= 7000 ? 'goal-achieved' : ''}`}>
                    <div className="calendar-month-statistic-title">
                        <p>Total Steps</p>
                        <DirectionsWalkIcon style={{ marginRight: '8px' }} />
                    </div>
                    <div className="calendar-month-statistic-value">
                        <span>
                            {monthStepsTotal}
                        </span>
                        <span> </span>
                        
                        <span><small>({averageSteps} Avg.)</small></span>
                    </div>
                </div>
                <div className={`calendar-month-statistic ${monthBikeTotal >= 600 ? 'goal-achieved' : ''}`}>
                    <div className="calendar-month-statistic-title">
                        <p>Cardio</p>
                        <DirectionsBikeIcon style={{ marginRight: '8px' }} />
                    </div>
                    <div className="calendar-month-statistic-value">
                        <span>{monthBikeTotal} <small>mins</small></span>
                        <span> </span>
                        {monthBikeTotal >= 600 && <CheckCircleOutlineIcon style={{ fontSize: '16px', color: 'green' }} />}
                        <span><small>({averageBike} Avg.)</small></span>
                    </div>
                </div>
                <div className="calendar-month-statistic">
                    <div className="calendar-month-statistic-title">
                        <p>Avg. Weight</p>
                        <MonitorWeightIcon style={{ marginRight: '8px' }} />
                    </div>
                    <div className="calendar-month-statistic-value">
                        <span>{averageWeight} <small>lbs</small></span>
                    </div>
                </div>

                {(() => {
                    const firstDayData = sortedActivityData.find(item => 
                        parseInt(item.activity_date_day) === 1 && 
                        parseInt(item.activity_date_month) === currentDate.getMonth() + 1 &&
                        parseInt(item.activity_date_year) === currentDate.getFullYear() &&
                        item.activity_weight !== "0"
                    );
                    
                    const lastDayData = [...sortedActivityData].reverse().find(item => 
                        parseInt(item.activity_date_month) === currentDate.getMonth() + 1 &&
                        parseInt(item.activity_date_year) === currentDate.getFullYear() &&
                        item.activity_weight !== "0"
                    );

                    avgWeight = firstDayData && lastDayData ? (parseFloat(firstDayData.activity_weight) - parseFloat(lastDayData.activity_weight)).toFixed(1) : 0;
                })()} 
                <div className={`calendar-month-statistic ${avgWeight >= 6 ? 'goal-achieved' : ''}`}>
                    <div className="calendar-month-statistic-title">
                        <p>Weight Lost</p>
                        <ImportExportIcon style={{ marginRight: '8px' }} />
                    </div>
                    <div className="calendar-month-statistic-value">
                        <span>
                            {avgWeight} <small>lbs</small>
                        </span>
                        <span> </span>
                        <span><small><strong>{weightToGo}</strong> to go</small></span>
                    </div>
                </div>
                <div className={`calendar-month-statistic ${totalPressUps >= 2000 ? 'goal-achieved' : ''}`}>
                    <div className="calendar-month-statistic-title">
                        <p>Pressups</p>
                        <ParaglidingIcon style={{ marginRight: '8px', transform: 'rotate(180deg)' }} />
                    </div>
                    <div className="calendar-month-statistic-value">
                        <span>{totalPressUps}</span> 
                        <span> </span>
                        {totalPressUps >= 2000 && <CheckCircleOutlineIcon style={{ fontSize: '16px', color: 'green' }} />}
                        
                        {totalPressUps < 2000 && (
                            <span> <small><strong>{2000 - totalPressUps}</strong> to go</small></span>
                        )}
                    </div>
                </div>
            </div>
            <div className="calendar">
                <div className="calendar-grid">
                    {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => (
                        <div key={day} className="day-header">{day}</div>
                    ))}
                    {days.map((day, i) => {
                        const dayData = day && sortedActivityData && sortedActivityData.filter(item => 
                            parseInt(item.activity_date_day) === day && 
                            parseInt(item.activity_date_month) === currentDate.getMonth() + 1 &&
                            parseInt(item.activity_date_year) === currentDate.getFullYear()
                        );
                        return (
                        <div 
                            key={i} 
                            className={`calendar-cell${day === new Date().getDate() && currentDate.getMonth() === new Date().getMonth() && currentDate.getFullYear() === new Date().getFullYear() ? ' active' : ''}${dayData && dayData.length > 0 && dayData[0].activity_alcohol !== false ? ' alcohol' : ''}${day === null ? ' inactive' : ''}`}
                            data-day={day ? day : ''}
                            data-month={currentDate.getMonth() + 1}
                            data-year={currentDate.getFullYear()}
                            onClick={() => { openDialogAndLoadData(day, currentDate.getMonth() + 1, currentDate.getFullYear()); }}
                        >
                            
                            <div className="calendar-day-header">
                                <div className="calendar-day-number">
                                    {day}
                                </div>
                                {dayData && dayData.length > 0 && dayData[0].activity_weight !== "0" &&  (
                                    (dayData[0].previous_weight >= dayData[0].activity_weight) ? 
                                    <CheckCircleOutlineIcon style={{ fontSize: '16px', color: 'green' }} />  : 
                                    <HighlightOffIcon style={{ fontSize: '16px', color: 'red' }} />
                                )}
                            </div>
                            {dayData && dayData.map(item => (
                                <div key={item.ID} className="calendar-day-activities">
                                    <div key={item.ID + "weight"} className="calendar-day-activities-weight">
                                        {item.activity_weight > 0 && <div className="activity-item weight"><MonitorWeightIcon style={{ fontSize: '12px', marginRight: '8px' }} />{parseFloat(item.activity_weight).toFixed(1)}</div>}
                                    </div>
                                    <div key={item.ID + "details"} className="calendar-day-activities-details">
                                        {item.activity_steps > 0 && <div className="activity-item steps"><DirectionsWalkIcon style={{ fontSize: '12px', fill: "#38bdf8" }} />{(item.activity_steps > 1000) ? (item.activity_steps / 1000).toFixed(1) + "k" : item.activity_steps}</div>}
                                        {item.activity_bike > 0 && <div className="activity-item bike"><DirectionsBikeIcon style={{ fontSize: '12px', fill: "#c084fc" }} />{item.activity_bike}</div>}
                                    </div>
                                    <div key={item.ID + "details2"} className="calendar-day-activities-details">
                                        {item.activity_strength > 0 && <div className="activity-item strength"><FitnessCenterIcon style={{ fontSize: '12px', fill: "#fb923c" }} /></div>}
                                        {item.activity_alcohol > 0 && <div className="activity-item alcohol"><LocalBarIcon style={{ fontSize: '12px', fill: "#d44646ff" }} /></div>}
                                        {item.activity_pressups > 0 && <div className="activity-item pressups"><ParaglidingIcon style={{ fontSize: '12px', fill: "#68d635", transform: "rotate(180deg)" }} />{item.activity_pressups}</div>}
                                    </div>
                                </div>
                            ))} 
                        </div>
                        );
                    })}
                </div>
            </div>
            <Dialog onClose={() => setDialogState(false)} open={dialogState} className="calendar-day-dialog">
                <h2>Activity for {dialogData.length > 0 ? dialogData[0].activity_date_day + getDaySuffix(dialogData[0].activity_date_day) + " " + new Date(dialogData[0].activity_date_year, dialogData[0].activity_date_month - 1).toLocaleString('default', { month: 'short' }) + " " + String(dialogData[0].activity_date_year).padStart(2, '0') : ''}</h2>
                <div className='calendar-day-dialog-weight-section'>
                    <div className='calendar-day-dialog-item'><p>Weight</p> <p>{dialogData.length > 0 ? parseFloat(dialogData[0].activity_weight).toFixed(1) + " lbs" : "N/A"}</p></div>
                    <div className='calendar-day-dialog-item'><p>Previous Weight</p> <p>{dialogData.length > 0 ? parseFloat(dialogData[0].previous_weight).toFixed(1) + " lbs" : "N/A"}</p></div>
                    <div className='calendar-day-dialog-item'><p>Weight Difference</p> <p>{dialogData.length > 0 ? (parseFloat(dialogData[0].activity_weight) - parseFloat(dialogData[0].previous_weight)).toFixed(1) + " lbs" : "N/A"}</p></div>
                </div>
                <div className='calendar-day-dialog-item'><p>Steps</p> <p>{dialogData.length > 0 ? dialogData[0].activity_steps : "N/A"}</p></div>
                <div className='calendar-day-dialog-item'><p>Cardio</p> <p>{dialogData.length > 0 ? dialogData[0].activity_bike + " mins" : "N/A"}</p></div>
                <div className='calendar-day-dialog-item'><p>Pressups</p> <p>{dialogData.length > 0 ? dialogData[0].activity_pressups : "N/A"}</p></div>
                <div className='calendar-day-dialog-item'><p>Strength</p> <p>{dialogData.length > 0 ? (dialogData[0].activity_strength ? "Yes" : "No") : "N/A"}</p></div>
                <div className='calendar-day-dialog-item'><p>Alcohol</p> <p>{dialogData.length > 0 ? (dialogData[0].activity_alcohol ? "Yes" : "No") : "N/A"}</p></div>
                <div className='calendar-day-dialog-notes'>
                    <p>Notes:</p> 
                    <div className='notes-section'>
                        <p>{dialogData.length > 0 ? dialogData[0].activity_notes : "N/A"}</p>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}